import { Chart, ChartFooterChard, Typography, colors, IconGraphy } from '@leapeasy/ui-kit';

export const AppTypeChart = ({ data, onClickItem }) => {
  const ldrCommercialCount = Number(data.LDRCCount || 0) + Number(data.LDRCount || 0);
  const rentGuarantyCount = Number(data.RGCount || 0);
  const guarantorWaiverCount = Number(data.AECount || 0);
  const sum = ldrCommercialCount + rentGuarantyCount + guarantorWaiverCount;

  return (
    <Chart
      variant="pie"
      pieMinAngle={30}
      data={[
        {
          name: 'LDR Commercial',
          value: sum ? (ldrCommercialCount / sum) * 100 : 0,
        },
        {
          name: 'Rent Guaranty',
          value: sum ? (rentGuarantyCount / sum) * 100 : 0,
        },
        {
          name: 'Guarantor Waiver Program',
          value: sum ? (guarantorWaiverCount / sum) * 100 : 0,
        },
      ]}
      containerStyles={{
        height: '100%',
      }}
      bodyStyles={{
        background: '#FEF0ED',
      }}
      colors={[colors.tomato[200], colors.tomato[75], colors.tomato[50]]}
      title="Expired Active Applications Types"
      description="Here is the detailed breakdown of expired active applications by type."
      icon={<IconGraphy icon="FileFolder.TextSnippet" />}
      footer={
        <div style={{ gap: '16px', width: '100%', display: 'flex', flexGrow: 1 }}>
          <div
            style={{
              gap: '12px',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <ChartFooterChard
              backgroundColor="#F9F8F9"
              activeColor={colors.tomato[200]}
              alignment="space-around"
              title={
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {ldrCommercialCount.toLocaleString()}
                </Typography>
              }
              content={
                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                  <Typography
                    variant="small"
                    style={{ fontWeight: '500', color: colors.neutral[900] }}
                  >
                    LDR Commercial
                  </Typography>
                </div>
              }
              onClick={() => onClickItem('LDR Commercial')}
              style={{ flex: '1 1 0%' }}
            />

            <ChartFooterChard
              backgroundColor="#F9F8F9"
              activeColor={colors.tomato[75]}
              alignment="space-around"
              title={
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {rentGuarantyCount.toLocaleString()}
                </Typography>
              }
              content={
                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                  <Typography
                    variant="small"
                    style={{ fontWeight: '500', color: colors.neutral[900] }}
                  >
                    Rent Guaranty
                  </Typography>
                </div>
              }
              onClick={() => onClickItem('Rent Guaranty')}
              style={{ flex: '1 1 0%' }}
            />
          </div>

          <div
            style={{
              gap: '12px',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
            }}
          >
            <ChartFooterChard
              backgroundColor="#F9F8F9"
              activeColor={colors.tomato[50]}
              alignment="space-around"
              title={
                <Typography variant="h4" style={{ fontWeight: '500', color: colors.purple[900] }}>
                  {guarantorWaiverCount.toLocaleString()}
                </Typography>
              }
              content={
                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                  <Typography
                    variant="small"
                    style={{ fontWeight: '500', color: colors.neutral[900] }}
                  >
                    Guarantor Waiver Program
                  </Typography>
                </div>
              }
              onClick={() => onClickItem('Guarantor Waiver Program')}
              style={{ flex: '1 1 0%' }}
            />

            <div style={{ flex: '1 1 0%' }} aria-hidden />
          </div>
        </div>
      }
    />
  );
};
